import PolicyLayout from "../components/PolicyLayout";

const sections = [
  {
    heading: "Objective",
    paragraphs: [
      "The objective of this Information Security Policy Statement is to ensure that Finncube Credit Services Pvt. Ltd. delivers a consistently high level of information security throughout the company.",
      "Finncube Credit Services Pvt. Ltd. is committed to implementing and maintaining compliance with ISO 27001, and to continuous, practical improvement of our information security practices.",
      "This commitment helps maintain our reputation in the industry and supports compliance with legal, regulatory, and customer requirements.",
    ],
  },
  {
    heading: "Implications",
    items: [
      "Clearly understanding the requirements and expectations of our customers and relevant regulatory authorities.",
      "Working closely with our customers and suppliers to deliver services in a security-conscious fashion.",
      "Ensuring every employee shares responsibility for effective information security.",
      "Protecting people, information, intellectual property, assets, activities, and facilities against misuse, loss, damage, disruption, interference, espionage, or unauthorised disclosure.",
      "Retaining the confidence of those who entrust sensitive information to Finncube Credit Services Pvt. Ltd.",
      "Developing and maintaining security policies and controls designed to meet the requirements of ISO 27001.",
      "Ensuring that the policy statements contained in the Information Security Policy (ISP), procedures, guidelines, and standards reflect the minimum requirements necessary to maintain an acceptable standard for protecting information assets and reputation.",
      "Implementing an Information Security Management System (ISMS) and ensuring it is maintained, continually improved, and supported with adequate resources to achieve the objectives set in this Policy Statement.",
      "Enhancing information security through investment in technology, processes, and employee skills to improve how the business is managed and how services are delivered to customers.",
      "Making this policy statement easily accessible to all staff and available for public viewing on the website.",
      "Requiring each member of staff to take particular care in their approach to security and accept the important role they play in maintaining an effective information security program throughout Finncube Credit Services Pvt. Ltd.",
    ],
  },
];

function InformationSecurityPolicy() {
  return (
    <PolicyLayout
      title="Information Security Policy"
      intro="This policy statement sets out Finncube Credit Services Pvt. Ltd.'s commitment to strong information security, ISO 27001-aligned controls, and continuous improvement across people, processes, and technology."
      lastUpdated="April 10, 2026"
      sections={sections}
    />
  );
}

export default InformationSecurityPolicy;
